import {TextProps, ViewStyle, Easing} from 'react-native';

import {_m} from 'INTL';
import SkillzStyle from 'SkillzStyle';
import {GAME_OPERATIONS_CONTAINER_MARGIN_TOP} from '../../GameOperationsManager.style';
import HomeScreenConstants from 'HomeScreenConstants';
import {BANNER_SIZE} from '@skillz/ui';

const {fullStyles} = SkillzStyle;

/** Conversation steps in the Game Operations Tutorial */
export type GameOperationsTutorialStep =
  | 'welcome'
  | 'highlightBanners'
  | 'highlightButtons'
  | 'completed';

export const GAME_OPERATION_CONTAINER_MARGIN_TOP =
  GAME_OPERATIONS_CONTAINER_MARGIN_TOP + HomeScreenConstants.getBalanceBarHeight();

const BANNER_HEIGHT = BANNER_SIZE?.height ?? 0;
const MARGIN_TOP = 130;
export const TUTORIAL_IMAGE_MARGIN_TOP =
  GAME_OPERATION_CONTAINER_MARGIN_TOP + BANNER_HEIGHT + MARGIN_TOP;

export const CONTAINER_STYLE: ViewStyle = {
  justifyContent: 'flex-start',
};

export const CONTENT_CONTAINER_STYLE: ViewStyle = {
  height: 144,
  marginHorizontal: 28,
  top: TUTORIAL_IMAGE_MARGIN_TOP,
};

export const BUBBLE_STYLE = {
  top: 0,
};

export const BUBBLE_TEXT_STYLE = {
  color: '#333333',
  fontSize: 15,
  lineHeight: 18,
  letterSpacing: -0.5,
  fontFamily: (fullStyles.fontExtraBold || fullStyles.fontBold).fontFamily,
};

export const BUBBLE_TEXT_PROPS: TextProps = {
  allowFontScaling: false,
  numberOfLines: 3,
};

export const BUBBLE_TEXT_CONTAINER_STYLE: ViewStyle = {
  paddingBottom: 0,
  paddingHorizontal: 14,
  alignItems: 'center',
};

export const BUBBLE_ANIMATION = {
  toValue: 1,
  duration: 700,
  easing: Easing.inOut(Easing.quad),
  useNativeDriver: true,
};

export const OVERLAY_GRADIENT_PROPS = {
  colors: ['rgba(0,0,0,.75)', 'rgba(0,0,0,.75)'],
  locations: [0, 1],
  start: {x: 1, y: 1},
  end: {x: 0, y: 0},
};
